import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { Invoice, InvoiceListResponse, SendInvoiceRequest } from '../types/invoice';

export const invoiceApi = {
	getList: async (locationId?: number): Promise<InvoiceListResponse> => {
		const query = locationId ? `?locationId=${locationId}` : '';
		return apiClient.get<InvoiceListResponse>(`${API_ENDPOINTS.INVOICE.LIST}${query}`);
	},

	getDetail: async (id: number): Promise<Invoice> => {
		return apiClient.get<Invoice>(API_ENDPOINTS.INVOICE.DETAIL(id));
	},

	send: async (data: SendInvoiceRequest): Promise<void> => {
		return apiClient.post(API_ENDPOINTS.INVOICE.SEND, data);
	},
};
